'use client'

import { useTheme } from 'next-themes'
import { type FC, useEffect } from 'react'
import { Tweet } from 'react-tweet'

declare global {
  interface Window {
    // biome-ignore lint/suspicious/noExplicitAny: TBD
    iFrameResize: any
  }
}

export interface TestimonialsProps {
  className?: string
}
export const Testimonials: FC<TestimonialsProps> = ({ className }) => {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.iFrameResize) {
      window.iFrameResize(
        { log: false, checkOrigin: false },
        '#testimonialto-backlinkgpt-tag-all-dark',
      )
    }
  }, [])

  const { resolvedTheme } = useTheme()
  // Convert next-themes' theme to react-tweet's theme format
  const tweetTheme = resolvedTheme === 'dark' ? 'dark' : 'light'

  const tweetIds = ['1881967116535882183', '1684793909463900160', '1892133783224381637']
  return (
    <div className={className}>
      <div
        className="mx-auto grid max-w-6xl grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3"
        data-theme={tweetTheme}
      >
        {tweetIds.map((tweetId) => (
          <div key={tweetId}>
            <Tweet id={tweetId} />
          </div>
        ))}
      </div>
    </div>
  )
}
